import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AngularMaterialModule } from './angular-material/angular-material.module';
import { FormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { DateInterceptor } from './interceptors/date-interceptor';
import { GuidInterceptor } from './interceptors/guid-interceptor';
import { PendingChangesGuard } from './pending-changes-guard';
import { UnsavedChangesDialogComponent } from './unsaved-changes-dialog/unsaved-changes-dialog.component';

@NgModule({
  declarations: [UnsavedChangesDialogComponent],
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    FormsModule,
    AngularMaterialModule
  ],
  exports: [
    CommonModule,
    AngularMaterialModule,
    FormsModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: DateInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: GuidInterceptor,
      multi: true,
    },
    PendingChangesGuard
  ]
})
export class SharedModule { }
